import { useCallback } from 'react'

export function useMergedRef<T>(...refs: (React.Ref<T> | undefined)[]): React.Ref<T> {
  return useCallback(
    (node: T | null) => {
      for (const ref of refs) {
        if (!ref) continue
        if (typeof ref === 'function') {
          ref(node)
        } else {
          // RefObject
          ;(ref as React.RefObject<T | null>).current = node
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    refs
  )
}
